import { render } from "./DistributorList.vue?vue&type=template&id=6e89fe86&scoped=true"
import script from "./DistributorList.vue?vue&type=script&lang=js"
export * from "./DistributorList.vue?vue&type=script&lang=js"

import "./DistributorList.vue?vue&type=style&index=0&id=6e89fe86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e89fe86"]])

export default __exports__